module.exports = __webpack_public_path__ + "static/img/ticketplus-logo-bk.9b4dac1e.svg";